<template>
    <div>
        <div v-if="loading" class="lds-dual-ring"></div>
        <ValidationObserver ref="form" v-else>
            <div class="form mt-3">
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group form-group-1">
                            <label for="" class="form-label">Select One:</label>
                            <div class="buttons-type-multiselect two-btns ">

                                <ValidationProvider
                                    name="Status"
                                    rules="required"
                                    v-slot="{ errors }"
                                    class="item active">
                                    <input
                                        type="radio"
                                        class="rad"
                                        id="id-1132"
                                        value="active"
                                        v-model="callOut.status"
                                    >
                                    <label for="id-1132">
                                        <span class="ttl">Active</span>
                                    </label>
                                    <FormError :error="errors[0]" name="Status"></FormError>
                                </ValidationProvider>

                                <div class="item inactive">
                                    <input
                                        type="radio"
                                        class="rad"
                                        id="id-1212"
                                        value="inactive"
                                        v-model="callOut.status"
                                    >
                                    <label for="id-1212">
                                        <span class="ttl">Inactive</span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row mb-3">
                    <div class="col-md-6" v-if="urlData.type === 'applicant'">
                        <label for="" class="form-label">Employee Name</label>
                        <input
                            type="text"
                            class="form-control"
                            :value="findName(urlData.id, 'applicant')"
                            readonly
                        >
                    </div>

                    <div class="col-md-6" v-if="urlData.type !== 'applicant'">
                        <div class="form-group form-group-1"
                        >
                            <CommonSearch
                                :label="'Employee Name'"
                                :type="'applicant'"
                                :selected-item="callOut.employee_id"
                                @update-info="updateEmployeeId"
                            />
                        </div>
                    </div>

                    <div class="col-md-6" v-if="urlData.type === 'client'">
                        <label for="" class="form-label">Location</label>
                        <input
                            type="text"
                            class="form-control"
                            :value="findName(urlData.id, 'client')"
                            readonly
                        >
                    </div>

                    <div v-if="urlData.type !== 'client'"
                         class="col-md-6"
                    >
                        <ValidationProvider
                            name="Location"
                            rules="required"
                            v-slot="{ errors }"
                            class="form-group form-group-1"
                        >
                            <label for="" class="form-label">Location</label>
                            <div class="form-group form-group-1">
                                <select
                                    class="custom-select"
                                    v-model="callOut.client_id"
                                >
                                    <option
                                        v-for="client in clientsList"
                                        :key="client.id"
                                        :value="client.id"
                                    >
                                        {{ client.name }}
                                    </option>
                                </select>
                                <FormError :error="errors[0]" name="Location"></FormError>
                            </div>
                        </ValidationProvider>
                    </div>

                    <ValidationProvider
                        class="col-md-6"
                        name="Date of call out"
                        rules="required"
                        v-slot="{ errors }"
                    >
                        <div class="form-group form-group-1">
                            <label for="" class="form-label">Date and time of call out</label>
                            <div class="form-group form-group-1 mb-0">
                                <input type="datetime-local"
                                       class="form-control"
                                       v-model="callOut.call_out_timestamps"
                                >
                                <FormError :error="errors[0]" name="Date of call out"></FormError>
                            </div>
                        </div>
                    </ValidationProvider>

                    <ValidationProvider
                        name="Call received by"
                        rules="required"
                        v-slot="{ errors }"
                        class="col-md-6"
                    >
                        <div class="form-group form-group-1">
                            <label for="" class="form-label">Call received by</label>
                            <input
                                type="text"
                                class="form-control"
                                v-model="callOut.call_received_by"
                            >
                            <FormError :error="errors[0]" name="Call received by"></FormError>
                        </div>
                    </ValidationProvider>

                    <ValidationProvider name="Open shift for Date"
                                        rules="required"
                                        v-slot="{ errors }" class="col-md-6">
                        <div class="form-group form-group-1">
                            <label for="" class="form-label">Open shift for Date/ Time</label>
                            <div class="form-group form-group-1 mb-0">
                                <input type="datetime-local"
                                       class="form-control"
                                       v-model="callOut.open_shift_timestamps"
                                >
                                <FormError :error="errors[0]" name="Open shift for Date"></FormError>
                            </div>
                        </div>
                    </ValidationProvider>

                    <div class="col-md-6">
                        <div class="form-group form-group-1">
                            <label for="" class="form-label">Ask if this call out is for one shift? </label>
                            <div class="buttons-type-multiselect two-btns">
                                <ValidationProvider
                                    name="call out is for one shift"
                                    rules="required"
                                    v-slot="{ errors }"
                                    class="item">
                                    <input
                                        type="radio"
                                        class="rad"
                                        id="id-11332"
                                        :value="true"
                                        v-model="callOut.isOneShift"
                                    >
                                    <label for="id-11332">
                                        <div class="ttl">Yes</div>
                                    </label>
                                    <FormError :error="errors[0]" name="call out is for one shift"></FormError>
                                </ValidationProvider>
                                <div class="item">
                                    <input
                                        type="radio"
                                        class="rad"
                                        id="id-12312"
                                        :value="false"
                                        v-model="callOut.isOneShift"
                                    >
                                    <label for="id-12312">
                                        <span class="ttl">No</span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <ValidationProvider name="Reason"
                                        rules="required"
                                        v-slot="{ errors }"
                                        class="col-md-12">
                        <div class="form-group form-group-1"
                        >
                            <label for="" class="form-label">Reason</label>
                            <input type="text" class="form-control" v-model="callOut.reason">
                            <FormError :error="errors[0]" name="Reason"></FormError>
                        </div>
                    </ValidationProvider>

                    <div class="col-md-12">
                        <div class="form-group form-group-1">
                            <label for="" class="form-label">If longer than one shift, or for vacation or extended time
                                off,
                                put
                                the information on the white board by</label>
                            <input type="text" class="form-control" v-model="callOut.longer_then_one_shift">
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="form-group form-group-1">
                            <label for="" class="form-label">List below those called for possible replacement: Called /
                                Left
                                Message / cannot work
                            </label>
                            <textarea type="text" class="form-control"
                                      v-model="callOut.possible_replacement"></textarea>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="form-group form-group-1">
                            <label for="" class="form-label">Replacement name</label>
                            <input type="text" class="form-control" v-model="callOut.replacement_name">
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group form-group-1">
                            <label for="" class="form-label">Updated TrackTik by</label>
                            <input type="text" class="form-control" v-model="callOut.track_tik_by">
                        </div>
                    </div>
                    <div class="col-3">
                        <div class="form-group form-group-1 ">
                            <label for="" class="form-label">Time it took to fill this shift:</label>
                            <input type="text" class="form-control" v-model="callOut.time_it_took">
                        </div>
                    </div>
                </div>
                <div class="box-ttl">Scheduling Department:</div>
                <div class="row mt-3">
                    <div class="col-md-6">
                        <div class="form-group form-group-1">
                            <label for="" class="form-label">Doctor's Note Info </label>
                            <input type="text" class="form-control" v-model="callOut.doctors_note">
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group form-group-1">
                            <label for="" class="form-label">Select One:</label>
                            <div class="buttons-type-multiselect two-btns">
                                <ValidationProvider
                                    class="item"
                                    name="Excused"
                                    rules="required"
                                    v-slot="{ errors }"
                                >
                                    <input
                                        type="radio"
                                        class="rad"
                                        id="id-11832"
                                        value="excused"
                                        v-model="callOut.doctor_status"
                                    >
                                    <label for="id-11832">
                                        <div class="ttl">Excused</div>
                                    </label>
                                    <FormError :error="errors[0]" name="Excused"></FormError>
                                </ValidationProvider>
                                <div class="item">
                                    <input
                                        type="radio"
                                        class="rad"
                                        id="id-12812"
                                        value="unexcused"
                                        v-model="callOut.doctor_status"
                                    >
                                    <label for="id-12812">
                                        <span class="ttl">Unexcused</span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="form-group form-group-1">
                            <label for="" class="form-label">Comments</label>
                            <textarea type="text" class="form-control" v-model="callOut.comments"></textarea>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="btns-wrap">
                            <button class="btn btn--outline-primary w-100 w-sm-auto" @click="getNextLink">Cancel
                            </button>
                            <button class="btn btn--secondary w-100 w-sm-auto" @click="validate">Save</button>
                        </div>
                    </div>
                </div>
            </div>
        </ValidationObserver>
    </div>


</template>

<script>
import CommonService from "../../../AppUser/resources/js/services/CommonService";
import CallOutService from "./services/CallOutService";
import VueMultiSelect from "../../../../../resources/js/plugins/VueMultiSelect.vue";
import CommonSearch from "../../../../../resources/js/components/CommonSearch.vue";
import ApplicantsServices from "../../../Applicants/resources/js/services/ApplicantsServices";

export default {
    name: "NewCallOut",
    components: {CommonSearch, VueMultiSelect},
    data() {
        return {
            loading: true,
            callOut: {
                status: null,
                employee_id: null,
                client_id: null,
                call_out_timestamps: null,
                open_shift_timestamps: null,
                call_received_by: null,
                isOneShift: null,
                reason: null,
                longer_then_one_shift: null,
                possible_replacement: null,
                replacement_name: null,
                track_tik_by: null,
                time_it_took: null,
                doctors_note: null,
                doctor_status: null,
                comments: null,
            },
            clientsList: [],
            searchedApplicant: null,
            urlData: {
                type: null,
                id: null,
            }
        }
    },
    methods: {
        async getApplicantInfo() {
            try {
                const {data: response} = await ApplicantsServices.getUserInfo(this.urlData.id)
                this.searchedApplicant = response
            } catch (e) {
            }
        },
        findName(id, type) {
            if (type === 'applicant') {
                return this.searchedApplicant.name + ' ' + this.searchedApplicant.last_name;
            } else if (type === 'client') {
                const found = this.clientsList.find(cl => cl.id === Number(id));
                if (found) {
                    return found.name;
                }
            }
            return null;
        },
        checkUrlParams(urlData) {
            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            if (urlParams.has('applicant')) {
                urlData.type = 'applicant';
                urlData.id = urlParams.get('applicant');
                this.callOut.employee_id = Number(urlData.id)
                this.getApplicantInfo()
            } else if (urlParams.has('client')) {
                urlData.type = 'client';
                urlData.id = urlParams.get('client');
                this.callOut.client_id = Number(urlData.id)
            } else {
                urlData.type = 'create';
                urlData.id = null;
            }

            this.loadData()
        },
        async loadData() {
            this.loading = true;

            try {
                await Promise.all([this.getClientsList()]);
            } catch (e) {
                console.error("Error loading data");
            } finally {
                this.loading = false;
            }
        },
        async getClientsList() {
            try {
                const {data: clients} = await CommonService.getClientsList()
                this.clientsList = clients
            } catch (e) {
                console.error()
                this.$showErrorMessage("List of location was not uploaded");
            }
        },
        updateEmployeeId(result) {
            this.callOut.employee_id = result
        },
        getNextLink() {
            if (this.urlData.type === 'applicant') {
                setTimeout(() => {
                    window.location.href = `/master-admin/applicants/${this.urlData.id}/show?tab=Call Out`
                }, 1000)
            } else if (this.urlData.type === 'client') {
                setTimeout(() => {
                    window.location.href = `/master-admin/sites-clients/${this.urlData.id}/profile?tab=Call Out`
                }, 1000)
            } else {
                setTimeout(() => {
                    window.location.href = `/master-admin/call-out`
                }, 1000)
            }
        },
        async validate() {
            const valid = await this.$refs.form.validate();
            if (!valid) {
                this.$showValidationErrorMessage();
            } else {
                await this.sendCallOut()
            }
        },
        async sendCallOut() {
            this.$showLoadingMessage()
            if (this.callOut.employee_id) {
                try {
                    await CallOutService.saveNewCallOut(this.callOut)
                    this.$showSuccessMessage('Your Call Out was sent')
                    this.getNextLink()
                } catch (e) {
                    this.$showErrorMessage();
                }
            } else {
                this.$showValidationErrorMessage('Please fill employee field');
            }
        }
    },
    mounted() {
        this.checkUrlParams(this.urlData)
    }

}

</script>


<style scoped>

</style>
